export const MAX_UPLOAD_FILE_SIZE = 500 * 1024 * 1024; // 500MB in bytes
